import React from "react"
import { Link } from "gatsby"
import { twMerge } from "tailwind-merge"
import { CheckIcon } from "@heroicons/react/24/solid"
import AirotopIcon from "../svg/tic/airotopIcon"
import WpIcon from "../svg/tic/wpIcon"
import FvIcon from "../svg/tic/fvIcon"
import OgIcon from "../svg/tic/ogIcon"
import PlasmidIcon from "../svg/tic/plasmidIcon"
import TcIcon from "../svg/tic/tcIcon"
import UyfIcon from "../svg/tic/uyfIcon"
// props: size[hero[default]] color[dark, light, white]
const PageButton = props => {
  return (
    <div
      className={twMerge([
        "rounded-md",
        props.light ? "" : "shadow",
        props.className,
      ])}
    >
      <Link
        onClick={props.onClick}
        to={props.to}
        className={twMerge([
          "flex items-center justify-center rounded-md border border-transparent py-3 text-base font-medium leading-6 transition",
          props.hero ? "px-8 md:px-10 md:py-4 md:text-lg" : "px-5",
          props.light
            ? "bg-blue-100 text-blue-700 hover:bg-blue-50 hover:text-blue-600 focus:border-blue-300 focus:outline-none focus:ring"
            : "",
          props.white
            ? "bg-white text-blue-600 hover:text-blue-500 focus:outline-none"
            : "",
          props.dark
            ? "bg-blue-600 text-white hover:bg-blue-500 focus:outline-none focus:ring"
            : "",
        ])}
      >
        {props.children}
      </Link>
    </div>
  )
}

const Button = React.forwardRef((props, ref) => {
  return (
    <div
      className={twMerge([
        "rounded-md",
        props.light ? "" : "shadow",
        props.className,
      ])}
    >
      <button
        ref={ref}
        type={props.type === `submit` ? `submit` : `button`}
        onClick={props.onClick}
        disabled={props.disabled}
        className={twMerge([
          "flex w-full items-center justify-center rounded-md border border-transparent py-3 text-base font-medium leading-6 transition",
          props.hero ? "px-8 md:px-10 md:py-4 md:text-lg " : "px-5",
          props.light
            ? "bg-blue-100 text-blue-700 hover:bg-blue-50 hover:text-blue-600 focus:border-blue-300 focus:outline-none focus:ring"
            : "",
          props.white
            ? "bg-white text-blue-600 hover:text-blue-500 focus:outline-none"
            : "",
          props.dark
            ? "bg-blue-600 text-white hover:bg-blue-500 focus:outline-none focus:ring"
            : "",
        ])}
      >
        {props.children}
      </button>
    </div>
  )
})

const LinkButton = props => {
  return (
    <div
      className={twMerge([
        "rounded-md",
        props.light ? "" : "shadow",
        props.className,
      ])}
    >
      <a
        href={props.href}
        rel="noreferrer"
        target={props.target ? props.target : undefined}
        disabled={props.disabled}
        className={twMerge([
          "flex items-center justify-center rounded-md border border-transparent py-3 text-base font-medium leading-6 transition",
          props.hero ? "px-8 md:px-10 md:py-4 md:text-lg" : "px-5",
          props.light
            ? "bg-blue-100 text-blue-700 hover:bg-blue-50 hover:text-blue-600 focus:border-blue-300 focus:outline-none focus:ring"
            : "",
          props.white
            ? "bg-white text-blue-600 hover:text-blue-500 focus:outline-none"
            : "",
          props.dark
            ? "bg-blue-600 text-white hover:bg-blue-500 focus:outline-none focus:ring"
            : "",
        ])}
      >
        {props.children}
      </a>
    </div>
  )
}

const PillLink = props => {
  return (
    <Link
      onClick={props.onClick}
      to={props.to}
      className={twMerge([
        "group",
        "inline-flex items-center hover:underline",
        props.large
          ? "mt-4 px-6 py-3 text-lg font-medium leading-8 shadow-lg transition hover:no-underline hover:shadow-md"
          : "px-2.5 py-0.5 text-xs font-medium leading-4",
        props.square ? "rounded-sm" : "rounded-full",
        props.color === "gray" &&
          "bg-slate-100 text-slate-800 hover:bg-slate-200",
        props.color === "pink" && "bg-pink-100 text-pink-800 hover:bg-pink-200",
        props.color === "red" && "bg-rose-100 text-rose-800 hover:bg-rose-200",
        props.color === "orange" &&
          "bg-orange-100 text-orange-800 hover:bg-orange-200",
        props.color === "yellow" &&
          "bg-amber-100 text-amber-800 hover:bg-amber-200",
        props.color === "green" &&
          "bg-emerald-100 text-emerald-800 hover:bg-emerald-200",
        props.color === "teal" && "bg-teal-100 text-teal-800 hover:bg-teal-200",
        props.color === "blue" && "bg-blue-100 text-blue-800 hover:bg-blue-200",
        props.color === "purple" &&
          "bg-violet-100 text-violet-800 hover:bg-violet-200",
        props.color === "indigo" &&
          "bg-indigo-100 text-indigo-800 hover:bg-indigo-200",
        props.className,
      ])}
    >
      <svg
        className={twMerge([
          "-ml-0.5 mr-1.5 h-2 w-2 fill-current",
          props.large ? "hidden" : "block",
          props.color === "gray" && "text-slate-600 group-hover:text-slate-800",
          props.color === "pink" && "text-pink-600 group-hover:text-pink-800",
          props.color === "red" && "text-rose-600 group-hover:text-rose-800",
          props.color === "orange" &&
            "text-orange-600 group-hover:text-orange-800",
          props.color === "yellow" &&
            "text-amber-600 group-hover:text-amber-800",
          props.color === "green" &&
            "text-emerald-600 group-hover:text-emerald-800",
          props.color === "teal" && "text-teal-600 group-hover:text-teal-800",
          props.color === "blue" && "text-blue-600 group-hover:text-blue-800",
          props.color === "purple" &&
            "text-violet-600 group-hover:text-violet-800",
          props.color === "indigo" &&
            "text-indigo-600 group-hover:text-indigo-800",
        ])}
        viewBox="0 0 8 8"
      >
        <circle cx="4" cy="4" r="3" />
      </svg>
      {props.children}
    </Link>
  )
}

const PillButton = props => {
  return (
    <button
      onClick={props.onClick}
      className={twMerge([
        "inline-flex items-center px-2.5 py-0.5 text-xs font-medium leading-4 hover:underline focus:outline-none",
        props.square ? "rounded-sm" : "rounded-full",
        props.color === "gray" &&
          "bg-slate-100 text-slate-800 hover:bg-slate-200",
        props.color === "gray" && props.active && "bg-slate-200",
        props.color === "pink" && "bg-pink-100 text-pink-800 hover:bg-pink-200",
        props.color === "pink" && props.active && "bg-pink-200",
        props.color === "red" && "bg-rose-100 text-rose-800 hover:bg-rose-200",
        props.color === "red" && props.active && "bg-rose-200",
        props.color === "orange" &&
          "bg-orange-100 text-orange-800 hover:bg-orange-200",
        props.color === "orange" && props.active && "bg-orange-200",
        props.color === "yellow" &&
          "bg-amber-100 text-amber-800 hover:bg-amber-200",
        props.color === "yellow" && props.active && "bg-amber-200",
        props.color === "green" &&
          "bg-emerald-100 text-emerald-800 hover:bg-emerald-200",
        props.color === "green" && props.active && "bg-emerald-200",
        props.color === "teal" && "bg-teal-100 text-teal-800 hover:bg-teal-200",
        props.color === "teal" && props.active && "bg-teal-200",
        props.color === "blue" && "bg-blue-100 text-blue-800 hover:bg-blue-200",
        props.color === "blue" && props.active && "bg-blue-200",
        props.color === "purple" &&
          "bg-violet-100 text-violet-800 hover:bg-violet-200",
        props.color === "purple" && props.active && "bg-violet-200",
        props.color === "indigo" &&
          "bg-indigo-100 text-indigo-800 hover:bg-indigo-200",
        props.color === "indigo" && props.active && "bg-indigo-200",
        props.className,
      ])}
    >
      <svg
        className={twMerge([
          props.active
            ? "-ml-0.5 mr-0.5 h-2 w-3 stroke-current stroke-2"
            : "-ml-0.5 mr-1.5 h-2 w-2 fill-current",
          props.color === "gray" && "text-slate-600 group-hover:text-slate-800",
          props.color === "gray" && props.active && "text-slate-800",
          props.color === "pink" && "text-pink-600 group-hover:text-pink-800",
          props.color === "pink" && props.active && "text-pink-800",
          props.color === "red" && "text-rose-600 group-hover:text-rose-800",
          props.color === "red" && props.active && "text-rose-800",
          props.color === "orange" &&
            "text-orange-600 group-hover:text-orange-800",
          props.color === "orange" && props.active && "text-orange-800",
          props.color === "yellow" &&
            "text-amber-600 group-hover:text-amber-800",
          props.color === "yellow" && props.active && "text-amber-800",
          props.color === "green" &&
            "text-emerald-600 group-hover:text-emerald-800",
          props.color === "green" && props.active && "text-emerald-800",
          props.color === "teal" && "text-teal-600 group-hover:text-teal-800",
          props.color === "teal" && props.active && "text-teal-800",
          props.color === "blue" && "text-blue-600 group-hover:text-blue-800",
          props.color === "blue" && props.active && "text-blue-800",
          props.color === "purple" &&
            "text-violet-600 group-hover:text-violet-800",
          props.color === "purple" && props.active && "text-violet-800",
          props.color === "indigo" &&
            "text-indigo-600 group-hover:text-indigo-800",
          props.color === "indigo" && props.active && "text-indigo-800",
        ])}
        viewBox="0 0 8 8"
      >
        {props.active ? <CheckIcon /> : <circle cx="4" cy="4" r="3" />}
      </svg>
      {props.children}
    </button>
  )
}

const TabLink = props => {
  return (
    <Link
      onClick={props.onClick}
      to={props.to}
      className={twMerge([
        "tabStyles",
        "flex h-10 w-10 items-center justify-center rounded-full",
        props.color === "gray" &&
          "bg-slate-400 text-white hover:bg-slate-600 hover:text-slate-100",
        props.color === "pink" &&
          "bg-pink-400 text-white hover:bg-pink-600 hover:text-pink-100",
        props.color === "red" &&
          "bg-rose-400 text-white hover:bg-rose-600 hover:text-rose-100",
        props.color === "orange" &&
          "bg-orange-400 text-white hover:bg-orange-600 hover:text-orange-100",
        props.color === "yellow" &&
          "bg-amber-400 text-white hover:bg-amber-600 hover:text-amber-100",
        props.color === "green" &&
          "bg-emerald-400 text-white hover:bg-emerald-600 hover:text-emerald-100",
        props.color === "teal" &&
          "bg-teal-400 text-white hover:bg-teal-600 hover:text-teal-100",
        props.color === "blue" &&
          "bg-blue-400 text-white hover:bg-blue-600 hover:text-blue-100",
        props.color === "purple" &&
          "bg-violet-400 text-white hover:bg-violet-600 hover:text-violet-100",
        props.color === "indigo" &&
          "bg-indigo-400 text-white hover:bg-indigo-600 hover:text-indigo-100",
        props.className,
      ])}
    >
      {props.svg}
      <span className="sr-only">{props.to}</span>
    </Link>
  )
}

const TabBlock = props => {
  return (
    <button
      onClick={props.onClick}
      className={twMerge([
        "border-radius:9999px .375rem .375rem 9999px;",
        "flex w-auto items-center justify-start px-1 py-1 transition focus:outline-none",
        props.color === "gray" && "bg-slate-50 hover:bg-slate-100",
        props.color === "gray" && props.active === true && "bg-slate-100",
        props.color === "pink" &&
          "bg-pink-50 text-pink-800 hover:bg-pink-100 hover:text-pink-900",
        props.color === "pink" && props.active === true && "bg-pink-100",
        props.color === "red" &&
          "bg-rose-50 text-rose-800 hover:bg-rose-100 hover:text-rose-900",
        props.color === "red" && props.active === true && "bg-rose-100",
        props.color === "orange" &&
          "bg-orange-50 text-orange-800 hover:bg-orange-100 hover:text-orange-900",
        props.color === "orange" && props.active === true && "bg-orange-100",
        props.color === "yellow" &&
          "bg-amber-50 text-amber-800 hover:bg-amber-100 hover:text-amber-900",
        props.color === "yellow" && props.active === true && "bg-amber-100",
        props.color === "green" &&
          "bg-emerald-50 text-emerald-800 hover:bg-emerald-100 hover:text-emerald-900",
        props.color === "green" && props.active === true && "bg-emerald-100",
        props.color === "teal" &&
          "bg-teal-50 text-teal-800 hover:bg-teal-100 hover:text-teal-900",
        props.color === "teal" && props.active === true && "bg-teal-100",
        props.color === "blue" &&
          "bg-blue-50 text-blue-800 hover:bg-blue-100 hover:text-blue-900",
        props.color === "blue" && props.active === true && "bg-blue-100",
        props.color === "purple" &&
          "bg-violet-50 text-violet-800 hover:bg-violet-100 hover:text-violet-900",
        props.color === "purple" && props.active === true && "bg-violet-100",
        props.color === "indigo" &&
          "bg-indigo-50 text-indigo-800 hover:bg-indigo-100 hover:text-indigo-900",
        props.color === "indigo" && props.active === true && "bg-indigo-100",
        props.className,
      ])}
    >
      <span
        className={twMerge([
          "svgStyles",
          "mr-2 flex h-10 w-10 items-center justify-center rounded-full text-white transition",
          props.color === "gray" &&
            "bg-slate-400 group-hover:bg-slate-600 group-hover:text-slate-100",
          props.color === "gray" &&
            props.active === true &&
            "bg-slate-600 text-slate-100",
          props.color === "pink" &&
            "bg-pink-400 group-hover:bg-pink-600 group-hover:text-pink-100",
          props.color === "pink" &&
            props.active === true &&
            "bg-pink-600 text-pink-100",
          props.color === "red" &&
            "bg-rose-400 group-hover:bg-rose-600 group-hover:text-rose-100",
          props.color === "red" &&
            props.active === true &&
            "bg-rose-600 text-rose-100",
          props.color === "orange" &&
            "bg-orange-400 group-hover:bg-orange-600 group-hover:text-orange-100",
          props.color === "orange" &&
            props.active === true &&
            "bg-orange-600 text-orange-100",
          props.color === "yellow" &&
            "bg-amber-400 group-hover:bg-amber-600 group-hover:text-amber-100",
          props.color === "yellow" &&
            props.active === true &&
            "bg-amber-600 text-amber-100",
          props.color === "green" &&
            "bg-emerald-400 group-hover:bg-emerald-600 group-hover:text-emerald-100",
          props.color === "green" &&
            props.active === true &&
            "bg-emerald-600 text-emerald-100",
          props.color === "teal" &&
            "bg-teal-400 group-hover:bg-teal-600 group-hover:text-teal-100",
          props.color === "teal" &&
            props.active === true &&
            "bg-teal-600 text-teal-100",
          props.color === "blue" &&
            "bg-blue-400 group-hover:bg-blue-600 group-hover:text-blue-100",
          props.color === "blue" &&
            props.active === true &&
            "bg-blue-600 text-blue-100",
          props.color === "purple" &&
            "bg-violet-400 group-hover:bg-violet-600 group-hover:text-violet-100",
          props.color === "purple" &&
            props.active === true &&
            "bg-violet-600 text-violet-100",
          props.color === "indigo" &&
            "bg-indigo-400 group-hover:bg-indigo-600 group-hover:text-indigo-100",
          props.color === "indigo" &&
            props.active === true &&
            "bg-indigo-600 text-indigo-100",
        ])}
      >
        {props.svg}
      </span>
      <span>{props.children}</span>
    </button>
  )
}

// ********** ==> ProdCTAlink <== **********
const ProdCTAlink = props => {
  return (
    <div className={twMerge(["group", "rounded-md shadow-lg hover:shadow-md"])}>
      <Link
        to={props.to}
        className={twMerge([
          props.svg ? `justify-start text-left` : `justify-center text-center`,
          "flex h-full w-auto items-center  overflow-hidden rounded-md py-1 pl-1 pr-6 shadow-md transition focus:outline-none group-hover:shadow-sm",
          props.color === "gray" && "bg-slate-100 hover:bg-slate-200",
          props.color === "pink" &&
            "bg-pink-100 text-pink-800 hover:bg-pink-200 hover:text-pink-900",
          props.color === "red" &&
            "bg-rose-100 text-rose-800 hover:bg-rose-200 hover:text-rose-900",
          props.color === "orange" &&
            "bg-orange-100 text-orange-800 hover:bg-orange-200 hover:text-orange-900",
          props.color === "yellow" &&
            "bg-amber-100 text-amber-800 hover:bg-amber-200 hover:text-amber-900",
          props.color === "green" &&
            "bg-emerald-100 text-emerald-800 hover:bg-emerald-200 hover:text-emerald-900",
          props.color === "teal" &&
            "bg-teal-100 text-teal-800 hover:bg-teal-200 hover:text-teal-900",
          props.color === "blue" &&
            "bg-blue-100 text-blue-800 hover:bg-blue-200 hover:text-blue-900",
          props.color === "purple" &&
            "bg-violet-100 text-violet-800 hover:bg-violet-200 hover:text-violet-900",
          props.color === "indigo" &&
            "bg-indigo-100 text-indigo-800 hover:bg-indigo-200 hover:text-indigo-900",
          props.className,
        ])}
      >
        {props.svg ? (
          <span
            className={twMerge([
              "svgStyles",
              "mr-2 flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-white transition",
              props.color === "gray" &&
                "bg-slate-400 group-hover:bg-slate-600 group-hover:text-slate-100",
              props.color === "gray" &&
                props.active === true &&
                "bg-slate-600 text-slate-100",
              props.color === "pink" &&
                "bg-pink-400 group-hover:bg-pink-600 group-hover:text-pink-100",
              props.color === "pink" &&
                props.active === true &&
                "bg-pink-600 text-pink-100",
              props.color === "red" &&
                "bg-rose-400 group-hover:bg-rose-600 group-hover:text-rose-100",
              props.color === "red" &&
                props.active === true &&
                "bg-rose-600 text-rose-100",
              props.color === "orange" &&
                "bg-orange-400 group-hover:bg-orange-600 group-hover:text-orange-100",
              props.color === "orange" &&
                props.active === true &&
                "bg-orange-600 text-orange-100",
              props.color === "yellow" &&
                "bg-amber-400 group-hover:bg-amber-600 group-hover:text-amber-100",
              props.color === "yellow" &&
                props.active === true &&
                "bg-amber-600 text-amber-100",
              props.color === "green" &&
                "bg-emerald-400 group-hover:bg-emerald-600 group-hover:text-emerald-100",
              props.color === "green" &&
                props.active === true &&
                "bg-emerald-600 text-emerald-100",
              props.color === "teal" &&
                "bg-teal-400 group-hover:bg-teal-600 group-hover:text-teal-100",
              props.color === "teal" &&
                props.active === true &&
                "bg-teal-600 text-teal-100",
              props.color === "blue" &&
                "bg-blue-400 group-hover:bg-blue-600 group-hover:text-blue-100",
              props.color === "blue" &&
                props.active === true &&
                "bg-blue-600 text-blue-100",
              props.color === "purple" &&
                "bg-violet-400 group-hover:bg-violet-600 group-hover:text-violet-100",
              props.color === "purple" &&
                props.active === true &&
                "bg-violet-600 text-violet-100",
              props.color === "indigo" &&
                "bg-indigo-400 group-hover:bg-indigo-600 group-hover:text-indigo-100",
              props.color === "indigo" &&
                props.active === true &&
                "bg-indigo-600 text-indigo-100",
            ])}
          >
            {props.svg === "FV" && <FvIcon />}
            {props.svg === "OG" && <OgIcon />}
            {props.svg === "UYF" && <UyfIcon />}
            {props.svg === "TC" && <TcIcon />}
            {props.svg === "Plasmid" && <PlasmidIcon />}
            {props.svg === "Airotop" && <AirotopIcon />}
            {props.svg === "WP" && <WpIcon />}
          </span>
        ) : (
          ``
        )}
        <span>{props.children}</span>
      </Link>
    </div>
  )
}

export {
  PageButton,
  Button,
  LinkButton,
  PillLink,
  PillButton,
  TabLink,
  TabBlock,
  ProdCTAlink,
}
